import { type GarmentGeometry, GarmentGeometryParser, type IScene } from '@seddi/scene';
import type { FileLoader } from '@seddi/ui-babylon-core';

export class GarmentGeometryLoader {
  /** File loader. */
  private readonly _fileLoader: FileLoader;

  constructor(fileLoader: FileLoader) {
    this._fileLoader = fileLoader;
  }

  /**
   * Loads a garment geometry surface.
   * @param data - garment geometry surface url.
   */
  loadAsync(scene: IScene, data: string): Promise<GarmentGeometry> {
    return this._fileLoader.loadUriAsync(data, data).then(raw => {
      const geometry = GarmentGeometryParser.Parse(raw, scene.children);
      return geometry;
    });
  }
}
